<div class="widget-container">
  <div
    class="widget-container__background"
    style="background-image: url('./assets/images/maldive.jpg')"
  >
    <div class="widget-container__engine">
      <app-search-engine></app-search-engine>
    </div>
  </div>
</div>
